// Craft: do not load browser telemetry SDKs or their fingerprinting plugins.
export default {};
